import GqlClient from 'utils/graphqlService';
import { gql } from '@apollo/client';

const query = gql`
  {
    activityCollection(
      where: { popular_exists: true, type: "News" }
      order: [popular_DESC]
      limit: 9
    ) {
      items {
        name
        slug
        image {
          url
        }
        imageUrl
      }
    }
  }
`;

const getPopularBlogs = async () => {
  const response = await GqlClient.query({
    query,
  });

  return response;
};

export default getPopularBlogs;
